import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { BUYING_REJECTION_MAP } from "../../constants";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";
import { recordSignupTermination } from "../../utils/flowActivityUtils";

class BuyingSorryPage extends Component {
  componentDidMount() {
    if (this.hasInitiated) return;
    this.hasInitiated = true;

    const reason = this.displayRejectionReason();
    if (reason) {
      recordSignupTermination(this.props.leadId, reason);
    } else {
      Sentry.captureMessage("BuyingSorryPage rendered without buyingRejectionReason", {
        tags: { component: "BuyingSorryPage" },
      });
    }
  }

  displayRejectionReason() {
    if (!this.props.buyingRejectionReason) return null;
    for (const [key, value] of this.props.buyingRejectionReason) {
      if (value) {
        return BUYING_REJECTION_MAP.get(key);
      }
    }
    return null;
  }

  render() {
    const rejectionReason = this.displayRejectionReason(); // something like "unregistered land"

    if (!rejectionReason) {
      return (
        <React.Fragment>
          <ScrollToTop />
          <Card title="We’re not able to help with this purchase" removeTopPadding>
            <p>We’re sorry — this type of property purchase falls outside what we’re currently able to help with.</p>
            <p>We wish you all the best with your move.</p>
          </Card>
          <Image src={imageOfficeWorking} fullWidth />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="We’re not able to help with this type of purchase" removeTopPadding>
          <p>
            We specialise in standard residential conveyancing, and purchases involving {rejectionReason} require
            specialist expertise that we’re not yet set up to offer.
          </p>
          <p>
            We’re sorry we can’t help you with this one. We hope that if your circumstances change in the future, you’ll
            consider Juno for your conveyancing.
          </p>
        </Card>
        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default BuyingSorryPage;
